import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { BsQuestionCircle } from "react-icons/bs";
import styles from "./cargo-badge.module.scss";
import { CargoType } from "../cargo-types/store/slice";

type Props = {
  type: CargoType | null;
  showText?: boolean;
};

const CargoBadge = ({ type }: Props) => {
  if (!type) return <span>-</span>;

  return (
    <div className={styles.wrapper}>
      <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip id={`status-${type.id}-tooltip`}>{type.group.name}</Tooltip>
        }
      >
        <span>
          {type.name} <BsQuestionCircle />
        </span>
      </OverlayTrigger>
    </div>
  );
};

export default CargoBadge;
